import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-4',
    title:
      'heading-xs text-text-inactive flex items-center justify-between pt-2 leading-[120%] font-medium tracking-[1.3px] uppercase',
    item: 'hover:text-icon-brand flex cursor-pointer items-center gap-3',
    icon: 'shrink-0 text-gray-500',
    text: 'heading-s line-clamp-1 leading-[140%]',
    removeAll: 'heading-s text-secondary-hover link tracking-wide',
    removeItem: 'flex-center ml-auto flex size-6 shrink-0 rounded-full bg-white'
  },
  variants: {
    color: {
      primary: 'text-main'
    },
    isRemovable: {
      true: {
        item: 'hover:bg-accent rounded-3xl'
      }
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
